<template>
  <div>
    <el-container>
      <el-main style="padding: 0; display: flex">
        <div style="width: 550px;box-sizing: border-box;overflow-x: hidden; overflow-y: auto;">
          <span>包装扫描</span>
          <el-divider/>
          <el-form
              ref="form"
              v-loading="submitLoading"
              style="width: 520px"
              :rules="ruleValidate"
              :model="model"
              class="form"
              label-width="90px"
              @submit.native.prevent>
            <el-form-item label="生产订单" prop="orders">
              <el-input
                  ref="orders"
                  v-model="model.orders"
                  placeholder="请扫描工单获取物料编号"
                  size="mini"
                  @keyup.enter.native.stop="getMaterialNo"/>
            </el-form-item>
            <el-form-item label="物料编号" prop="materialNo">
              <el-input
                  v-model="model.materialNo"
                  disabled
                  placeholder="请扫描工单获取物料编号"
                  size="mini"/>
            </el-form-item>
            <el-form-item label="序列号" prop="snSerialNo">
              <el-input
                  ref="snSerialNoInput"
                  v-model="model.snSerialNo"
                  placeholder="请扫描序列号"
                  size="mini"
                  @keyup.enter.native.stop="capture"/>
            </el-form-item>
            <div>
              <div
                  style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
                拍照上传
              </div>
              <div
                  style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
                <el-button v-if="devices.length > 1" type="success" @click="switchCamera">切换摄像头</el-button>
              </div>
              <div style="margin-bottom: 10px;">
                <div v-loading="videoLoading" style="display: flex;">
                  <video ref="video" style="flex: 1; width: 0" autoplay/>
                  <canvas ref="canvas" style="flex: 1;margin-left: 10px; width: 0"/>
                </div>
              </div>
            </div>
          </el-form>
        <!--        <span slot="footer">-->
        <!--          <el-button-->
        <!--              :loading="submitLoading"-->
        <!--              type="primary"-->
        <!--              @click="packScanByHand">-->
        <!--            手动完工-->
        <!--          </el-button>-->
        <!--        </span>-->
        </div>
        <!-- 历史扫码记录 -->
        <scan-history-comp
            ref="scanHistoryComp"
            title="历史扫码记录"
            :storage-key-prefix="storageKey"
            :delete-auth-index="757"
            @update-model="updateModel"
            @update-can-scan="updateCanScan"
        />
      </el-main>
    </el-container>
    <!-- 订单信息 -->
    <order-infor-comp ref="orderInforComp" :scan-key="storageKey"/>
  </div>
</template>

<script>
  // import axios from "axios";
  import ossUtil from "../../../util/ossUtil";
  import ScanHistoryComp from "./ScanHistoryComp.vue";
  import OrderInforComp from "./OrderInforComp.vue";
  export default {
    name: "PackScan",
    components: {
      ScanHistoryComp, OrderInforComp,
    },
    data() {
      return {
        uploadProgress: "点击上传",
        model: {
          orders:"",
          snSerialNo: "",
          postDate: "",
          materialNo:"",
          attachments: [],
        },
        dialogVisible: false,
        stream: null,
        devices: [],
        currentDeviceId: null,
        videoLoading: false,
        submitLoading: false,
        canScan: true, // 是否可以扫描， 当全部报工后，没有清空当前记录，则不能再继续报工了
        // localStorage key 前缀（动态传入，用于区分不同页面）
        storageKey: "PackScan",
        ruleValidate: {
          snSerialNo: [
            {
              required: true,
              message: "序列号不可为空",
              trigger: "blur",
            },
          ],
          materialNo: [
            {
              required: true,
              message: "物料编号不可为空",
              trigger: "blur",
            },
          ],
        },
      };
    },
    async mounted() {
      this.initData();
      await this.initializeCamera();
    },
    beforeUnmount() {
      this.stopCamera();
    },
    methods: {
      initData() {
        let list = this.$refs.scanHistoryComp.currentBarcodes;
        if (list.length>0) {
          this.model.orders = list[list.length-1].orders;
          this.model.materialNo = list[list.length-1].materialNo;
        }
      },
      updateModel() {
        this.model.orders = "";
        this.model.materialNo = "";
      },
      updateCanScan(canScan) {
        this.canScan = canScan;
      },
      // 根据序列号获取订单信息
      getOrderInfo(sn) {
        this.submitLoading = true;
        return this.$http.get("basic", `sapProductionOrders/getInfoBySn/${sn}`).then((res) => {
          const { success, data } = res;
          if (success) {
            this.model.orders = data.orders;
            this.model.materialNo = data.materialNo;
          }
        }).finally(() => {
          this.submitLoading = false;
        });
      },
      // 上传图片
      async capture() {
        if (!this.canScan) {
          return this.$message.error("当前记录已全部报工，请先清空后再进行新的扫描！");
        }
        if (!this.model.materialNo) {
          await this.getOrderInfo(this.model.snSerialNo);
          if (this.$refs.orderInforComp) {
            this.$refs.orderInforComp.getData(this.model.orders);
          }
          return;
        }
        this.submitLoading = true;
        const video = this.$refs.video;
        const canvas = this.$refs.canvas;
        const context = canvas.getContext("2d");

        // 设置 canvas 尺寸与视频一致
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (!blob) {
            this.submitLoading = false;
            this.$message.error("摄像头未打开或拍照失败，请检查设备后重试！");
            return;
          }

          // 生成文件名（如 snapshot-时间戳.jpg）
          const fileName = "包装扫描_" + this.model.snSerialNo+".jpg";
          const file = new File([blob], fileName, { type: "image/png" });
          let params = {
            file: file,
          };
          this.submitUpload(params);
        }, "image/png", 0.9);
      },

      async switchCamera() {
        const currentIndex = this.devices.findIndex(
          d => d.deviceId === this.currentDeviceId
        );
        const newDevice = this.devices[(currentIndex + 1) % this.devices.length];

        this.stopCamera();
        await this.initializeCamera(newDevice.deviceId);
      },
      stopCamera() {
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
        }
      },
      async initializeCamera(deviceId) {
        try {
          this.videoLoading= true;
          const constraints = {
            video: deviceId ? { deviceId: { exact: deviceId } } : true,
          };

          // 获取视频流
          const stream = await navigator.mediaDevices.getUserMedia(constraints);
          this.stream = stream;

          // 获取可用摄像头设备
          if (!deviceId) {
            const devices = await navigator.mediaDevices.enumerateDevices();
            this.devices = devices.filter(device => device.kind === "videoinput");
          }

          // 显示视频流
          this.$refs.video.srcObject = stream;
          this.currentDeviceId = stream.getVideoTracks()[0].getSettings().deviceId;
          this.videoLoading= false;
        } catch (error) {
          console.error("摄像头访问失败:", error);
          this.videoLoading= false;
        }
      },
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate + " 00:00:00";
      },

      submitUpload({file}) {
        this.submitLoading = false;
        ossUtil.upload(file, false, false, this.handleUploadProgress).then(res => {
          this.model.fileName = "包装扫描_" + this.model.snSerialNo;
          if (!res.url.includes("https")) {
            this.model.filePath = (res.url).replaceAll("http","https");
          }else {
            this.model.filePath = res.url;
          }
          this.$message.success("上传成功，点击保存后生效");
          this.submitLoading = false;
          this.handleSubmit();
        }).catch(error => {
          this.submitLoading = false;
          this.$message.error("上传失败：" + error);
        });
      },
      handleUploadProgress(p) {
        this.uploadProgress = "正在上传 " + (p * 100).toFixed(2) + "%";
      },
      fileDelete(index) {
        this.model.attachments.splice(index, 1);
      },
      handleSubmit() {
        this.$http
          .post("basic", "sapProductionOrders/packScan", this.model)
          .then((resp) => {
            if (resp.success) {
              // 保存条形码到历史记录
              if (this.$refs.scanHistoryComp) {
                this.$refs.scanHistoryComp.saveBarcode(this.model.snSerialNo,this.model.orders,this.model.materialNo);
              }
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$playScanSuccess();
              this.$message.success("保存成功");
              this.clearSnSerialNo();
            } else {
              this.$playScanFailure();
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      packScanByHand() {
        this.$http
          .post("basic", "sapProductionOrders/packScanByHand", this.model)
          .then((resp) => {
            if (resp.success) {
              // 保存条形码到历史记录
              if (this.$refs.scanHistoryComp) {
                this.$refs.scanHistoryComp.saveBarcode(this.model.snSerialNo,this.model.orders,this.model.materialNo);
              }
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$playScanSuccess();
              this.$message.success("保存成功");
              this.clearSnSerialNo();
            } else {
              this.$playScanFailure();
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      // 清空序列号并focus
      clearSnSerialNo() {
        this.model.snSerialNo = "";
        this.$nextTick(() => {
          this.$refs.snSerialNoInput.focus();
        }); 
      },

      getMaterialNo() {
        if (!this.canScan) {
          return this.$message.error("当前记录已全部报工，请先清空后再进行新的扫描！");
        }
        this.$http.get("basic",`sapProductionOrders/getByNo/${this.model.orders}`)
          .then(resp => {
            if(resp.success) {
              this.model.orders=resp.data.orders;
              this.model.materialNo=resp.data.materialNo;
              if (this.$refs.orderInforComp) {
                this.$refs.orderInforComp.getData(this.model.orders);
              }
            }});

      },
    },
  };
</script>

<style lang="scss" scoped>
  .vm-separate {
    margin-top: 10px;
  }
  ::v-deep .el-container {
    height: 50vh;
  }
</style>